import React, { useState, useEffect } from 'react';
import {
  Container, Row, Col, Table, Button, Form, Pagination,
  InputGroup, Image, Modal
} from 'react-bootstrap';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import axios from 'axios';
import { BsTrash, BsSearch, BsSortDown, BsSortUp, BsPencil } from 'react-icons/bs';
import { API_ENDPOINTS } from '../config';

const defaultProfilePic = "/images/avatar.png";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [usersPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortField, setSortField] = useState('name');
  const [sortDirection, setSortDirection] = useState('asc');
  const [showEditModal, setShowEditModal] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [editPasswordUser, setEditPasswordUser] = useState(null);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await axios.get(API_ENDPOINTS.getAllUsers, {
        headers: { 'token': localStorage.getItem('token') }
      });
      setUsers(response.data.users);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  const sortUsers = (field) => {
    setSortDirection(field === sortField ? (sortDirection === 'asc' ? 'desc' : 'asc') : 'asc');
    setSortField(field);
  };

  const sortedAndFilteredUsers = users
    .filter(user =>
      user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.email.toLowerCase().includes(searchTerm.toLowerCase())
      
    )
    .sort((a, b) => {
      if (a[sortField] < b[sortField]) return sortDirection === 'asc' ? -1 : 1;
      if (a[sortField] > b[sortField]) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = sortedAndFilteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleDeleteUser = async (userId) => {
    if (window.confirm('Are you sure you want to delete this user?')) {
      try {
        await axios.delete(API_ENDPOINTS.deleteUser, {
          headers: {
            'token': localStorage.getItem('token'),
            'userId': userId
          }
        });
        fetchUsers();
      } catch (error) {
        console.error('Error deleting user:', error);
      }
    }
  };

  const handleEditUser = (user) => {
    setEditUser(user);
    setShowEditModal(true);
  };

  const handleChangePasswordUser = (user) => {
    //console.log(API_ENDPOINTS.editUser,"fsdfsdfdf",user);
    setEditPasswordUser(user);
    setShowChangePasswordModal(true);
  };

  const handleSaveEdit = async () => {
    try {

      await axios.patch(API_ENDPOINTS.editUser, editUser, {
        headers: {
          'token': localStorage.getItem('token'),
          'userId': editUser.userId
        }
      });
      setShowEditModal(false);
      fetchUsers();
    } catch (error) {
      console.error('Error updating user:', error);
    }
  };

  const handleSavePassword = async () => {
    try {
      console.log(localStorage.getItem('token'))
      await axios.patch(API_ENDPOINTS.changepassword, editPasswordUser, {
        headers: {
          'token': localStorage.getItem('token'),
          'userId': editPasswordUser.providerId
        }
      });
      setShowChangePasswordModal(false);
      fetchUsers();
    } catch (error) {
      console.error('Error updating user:', error);
    }
  };

  const handleToggleActive = async (userId, isActive) => {
    try {

      const response = await axios.patch(API_ENDPOINTS.toggleUserActiveStatus,
        { isActive: !isActive },  // Move userId to headers
        {
          headers: {
            'token': localStorage.getItem('token'),
            'userId': userId, // Add userId in the headers
          },
        }
      );
  
      if (response.status === 200) {
        setUsers((prevUsers) =>
          prevUsers.map((user) =>
            user.userId === userId ? { ...user, isActive: !isActive } : user
          )
        );
      } else {
        console.error(`Failed to toggle user status: ${response.statusText}`);
        alert(`Error: Could not update user status. Please try again later.`);
      }
    } catch (error) {
      if (error.response) {
        console.error(`Server Error: ${error.response.status} - ${error.response.data.message || error.response.statusText}`);
        alert(`Error ${error.response.status}: ${error.response.data.message || "Failed to update user status. Please try again later."}`);
      } else if (error.request) {
        console.error("Network Error: No response received from server.");
        alert("Network Error: Could not reach the server. Please check your connection.");
      } else {
        console.error("Request Error:", error.message);
        alert(`Request Error: ${error.message}. Please try again.`);
      }
    }
  };

  return (
    <div className="d-flex">
      <Sidebar style={{ position: 'fixed', top: 0, bottom: 0, left: 0, width: '250px', zIndex: 1000 }} />
      <div style={{ width: 'calc(100%)', height: 'calc(100vh)', overflowY: 'auto' }}>
        <Header style={{ position: 'fixed', top: 0, left: '250px', width: 'calc(100% - 250px)', zIndex: 1000 }} />
        <Container fluid className="mt-3">
          <Row>
            <Col>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h2>Users</h2>
              </div>
              <InputGroup className="mb-3">
                <InputGroup.Text><BsSearch /></InputGroup.Text>
                <Form.Control
                  placeholder="Search users..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </InputGroup>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th onClick={() => sortUsers('name')}>
                      Name {sortField === 'name' && (sortDirection === 'asc' ? <BsSortUp /> : <BsSortDown />)}
                    </th>
                    <th onClick={() => sortUsers('email')}>
                      Email {sortField === 'email' && (sortDirection === 'asc' ? <BsSortUp /> : <BsSortDown />)}
                    </th>
                    <th>User Type</th>
                    <th>Profile Picture</th>
                    <th>User ID</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentUsers.map((user) => (
                    <tr key={user.userId}>
                      <td>{user.name}</td>
                      <td>{user.email}</td>
                      <td>{user.usertype}</td>
                      <td>
                        <Image
                          src={user.profilePic || defaultProfilePic}
                          alt={user.name}
                          fluid
                          style={{ width: '80px', height: '80px', objectFit: 'cover'}}
                        />
                      </td>
                      <td>{user.userId}</td>
                      <td>
                        <Form.Check
                          type="switch"
                          id={`active-switch-${user.userId}`}
                          checked={user.isActive}
                          onChange={() => handleToggleActive(user.userId, user.isActive)}
                          label={user.isActive ? 'Active' : 'Inactive'}
                        />
                      </td>
                      <td className="d-flex align-items-center">
                        <Button variant="info" onClick={() => handleEditUser(user)} className="me-2">
                          <BsPencil />
                        </Button>
                        {/* <Button variant="danger" onClick={() => handleDeleteUser(user.userId)}>
                          <BsTrash />
                        </Button> */}
                        <Button variant="info" onClick={() => handleChangePasswordUser(user)} className="me-2">
                         Change Password
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <Pagination>
                {[...Array(Math.ceil(sortedAndFilteredUsers.length / usersPerPage)).keys()].map(number => (
                  <Pagination.Item key={number + 1} active={number + 1 === currentPage} onClick={() => paginate(number + 1)}>
                    {number + 1}
                  </Pagination.Item>
                ))}
              </Pagination>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Edit User Modal */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit User</Modal.Title> 
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                value={editUser?.name || ''}
                onChange={(e) => setEditUser({ ...editUser, name: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                value={editUser?.email || ''}
                onChange={(e) => setEditUser({ ...editUser, email: e.target.value })}
              />
            </Form.Group>
            <Form.Group controlId="isPremium" className="mt-2">
              <Form.Label>isPremium</Form.Label>
                <Form.Control
                    as="select"
                    name="isPremium"
                    value={editUser?.isPremium || ''}
                    onChange={(e) => setEditUser({ ...editUser, isPremium: e.target.value })}
                  >
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </Form.Control>
            </Form.Group>
            <Form.Group controlId="isExpert" className="mt-2">
              <Form.Label>isExpert</Form.Label>
                <Form.Control
                    as="select"
                    name="isExpert"
                    value={editUser?.isExpert || ''}
                    onChange={(e) => setEditUser({ ...editUser, isExpert: e.target.value })}
                  >
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </Form.Control>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditModal(false)}>Cancel</Button>
          <Button variant="primary" onClick={handleSaveEdit}>Save Changes</Button>
        </Modal.Footer>
      </Modal>

        { /* ----------------- Change Password */ }
        <Modal show={showChangePasswordModal} onHide={() => setShowChangePasswordModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Changes Password</Modal.Title> 
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="text"
                name="password"
                onChange={(e) => setEditPasswordUser({ ...editPasswordUser, password: e.target.value })}
                 
              />
            </Form.Group>
            
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowChangePasswordModal(false)}>Cancel</Button>
          <Button variant="primary" onClick={handleSavePassword}>Save Changes</Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};

export default Users;
